// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';

// helpers
import { COLORS, BREAKPOINTS } from 'shared/styles/base';
import { DEVICE_TYPE, getDeviceType } from 'shared/helpers/app';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

const Disclaimer = styled.div`
  width: 100%;
  box-sizing: border-box;

  ${({ theme }) => `
      background: ${hexToRgb(theme.colors.info, 0.08)};
      border: 1px solid ${hexToRgb(theme.colors.info10, 0.16)};
      border-radius: ${theme.borders.radius10};
      margin: ${theme.spacing.spacing80} 0;
      padding-right: ${theme.spacing.spacing60};
  `};

  ${({ theme }) => theme.typography.bodyMedium};

  ${({ theme }) =>
    `
      align-items: flex-start;
      .icon-wrapper{
        margin-top:  ${theme.spacing.spacing60};
        margin-bottom:  ${theme.spacing.spacing60};
      }`};

  display: flex;
  .text {
    ${({ theme }) => `
        color: ${theme.colors.textPrimary};
        padding: ${theme.spacing.spacing60} 0;
    `};
    ${({ theme }) => theme.typography.bodySmall};
    @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      padding: 0;
    }
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => `
      margin: ${theme.spacing.spacing120} 0 0;
      padding: ${theme.spacing.spacing80};
      .text {
        ${theme.typography.bodyMedium};
      }
   `};
    ${({ theme }) => theme.typography.bodyLarge};
  }
`;

const IconWrapper = styled.div`
  ${({ theme }) => `margin: ${theme.spacing.spacing80} ${theme.spacing.spacing60}`};
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    &.icon-wrapper {
      ${({ theme }) => `margin: 0 ${theme.spacing.spacing80} 0 0`};
    }
  }
`;

const Title = styled.div`
  ${({ theme }) => `margin-bottom: ${theme.spacing.spacing10}`};
  ${({ theme }) => theme.typography.labelMedium};
  text-transform: uppercase;
`;

interface IDisclaimerTextProps {
  disclaimer?: string;
  title?: string;
  className?: string;
}

function DisclaimerText({ disclaimer, title, className = '' }: IDisclaimerTextProps) {
  const isMobile = getDeviceType() === DEVICE_TYPE.MOBILE;
  const AlertInfoFilledIcon = useStoreIcon(IconName.ALERT_INFO_FILLED);

  if (!disclaimer) {
    return null;
  }

  return (
    <Disclaimer className={className}>
      <IconWrapper className="icon-wrapper">
        <AlertInfoFilledIcon color={COLORS.INFO} size={isMobile ? '20px' : '24px'} />
      </IconWrapper>
      <div className="text" data-test="disclaimer-text">
        {title && <Title>{title}</Title>}
        {disclaimer}
      </div>
    </Disclaimer>
  );
}

export default memo(DisclaimerText);
